import clsx from "clsx";
import React, { Children } from "react";

interface Props {
  fullWidth?: boolean;
  children?: React.ReactNode | [React.ReactNode, React.ReactNode];
  className?: string;
}

export const InputRow = ({ fullWidth = true, children, className }: Props) => {
  const hasOneComponent = Children.count(children) === 1;

  return (
    <div
      className={clsx(
        "grid w-full grow gap-x-6 gap-y-10 lg:grid-cols-auto-fit",
        {
          "lg:!w-[50%] lg:pr-3": hasOneComponent && !fullWidth,
          "!w-full": hasOneComponent && fullWidth,
        },
        className,
      )}
    >
      {children}
    </div>
  );
};
